
<!--div class="container" *ngIf="view">
  <mat-card class="card">
    <mat-card-title><img mat-card-image src="https://tdemperu.com/tdem/wp-content/uploads/2025/01/LOGO-TDEM-original.jpg" alt="TDEM SRL"></mat-card-title>
    <div class="line"></div>
    <mat-card-subtitle>	Consulta de Certificado</mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="certificadoForm" novalidate (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline"  class="full-width" *ngIf="codigoHash">
          <mat-label>Código Seguridad <span class="span-required">*</span></mat-label>
          <input matInput type="text" placeholder="Código Seguridad" formControlName="CODIGO_SEGURIDAD" >
        </mat-form-field>
        
        <mat-form-field appearance="outline"  class="full-width" *ngIf="!codigoHash">
          <mat-label>Número de Certificado<span class="span-required">*</span></mat-label>
          <input matInput type="text" placeholder="Número Certificado" formControlName="NRO_CERTIFICADO" >
        </mat-form-field>
        
        <mat-form-field appearance="outline"  class="full-width" *ngIf="!codigoHash">
          <mat-label>Número de Suministro<span class="span-required">*</span></mat-label>
          <input matInput type="text" placeholder="Número Suministro" formControlName="NRO_SUMINSTRO" >
        </mat-form-field>

        <button mat-raised-button type="submit"  class="full-width button-color">CONSULTAR</button>
      </form>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="!view">
  <mat-toolbar class="toolbar-color">
      <img mat-card-image src="https://tdemperu.com/tdem/wp-content/uploads/2025/01/LOGO-TDEM-original.jpg" alt="Photo of a Shiba Inu">
      <span class="title">Consulta de certificados de inspección</span>
      <span class="example-spacer"></span>
      <button mat-icon-button class="example-icon class-button" aria-label="Example icon-button with share icon" (click)="exit()">
          <mat-icon>power_settings_new</mat-icon>Salir
      </button>
  </mat-toolbar>
  <div class="iframe-container">
      <iframe [src]="urlPDF" width="800" height="1160"></iframe>
  </div>
</div-->

<!--div class="container" *ngIf="view">
  <mat-card class="card">
    <mat-card-title>
      <img mat-card-image src="https://tdemperu.com/tdem/wp-content/uploads/2025/01/LOGO-TDEM-original.jpg" alt="TDEM SRL">
    </mat-card-title>
    <div class="line"></div>
    <mat-card-subtitle>Consulta de Certificado</mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="certificadoForm" novalidate (ngSubmit)="onSubmit()">
        
        <mat-form-field appearance="outline" class="full-width" *ngIf="codigoHash">
          <mat-label>Código Seguridad <span class="span-required">*</span></mat-label>
          <input matInput type="text" placeholder="Código Seguridad" formControlName="CODIGO_SEGURIDAD">
        </mat-form-field>
        
        <div *ngIf="!codigoHash">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Proyecto <span class="span-required">*</span></mat-label>
            <mat-select formControlName="PROYECTO" placeholder="Seleccione proyecto">
              <mat-option *ngFor="let proyecto of proyectosConfig" [value]="proyecto.proyecto">
                {{ proyecto.proyecto }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Fecha <span class="span-required">*</span></mat-label>
            <input matInput [matDatepicker]="picker" formControlName="FECHA" placeholder="Seleccione fecha">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <div *ngIf="showProjectFields">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Número de Certificado<span class="span-required">*</span></mat-label>
              <input matInput type="text" placeholder="Número Certificado" formControlName="NRO_CERTIFICADO">
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Número de Suministro<span class="span-required">*</span></mat-label>
              <input matInput type="text" placeholder="Número Suministro" formControlName="NRO_SUMINSTRO">
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="isLoading" style="margin: 12px 0; text-align:center;">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <div style="margin-top:8px; font-size: 13px;">{{ loadingText }}</div>
        </div>
        
        <button mat-raised-button type="submit" class="full-width button-color" 
                [disabled]="codigoHash ? certificadoForm.invalid : (!showProjectFields || certificadoForm.invalid)">
          CONSULTAR
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="!view">
  <mat-toolbar class="toolbar-color">
    <img mat-card-image src="https://tdemperu.com/tdem/wp-content/uploads/2025/01/LOGO-TDEM-original.jpg" alt="TDEM SRL">
    <span class="title">Consulta de certificados de inspección</span>
    <span class="example-spacer"></span>
    <button mat-icon-button class="example-icon class-button" aria-label="Example icon-button with share icon" (click)="exit()">
      <mat-icon>power_settings_new</mat-icon>Salir
    </button>
  </mat-toolbar>
  <div class="iframe-container">
    <iframe [src]="urlPDF" width="800" height="1160"></iframe>
  </div>
</div-->
<div class="page" *ngIf="view">
  <mat-card class="card">
    <div class="brand">
      <img class="brand__logo"
           src="https://tdemperu.com/tdem/wp-content/uploads/2025/01/LOGO-TDEM-original.jpg"
           alt="TDEM SRL">
      <div class="brand__text">
        <div class="brand__title">Consulta de Certificado</div>
        <div class="brand__subtitle">Verificación de certificados de inspección</div>
      </div>
    </div>

    <div class="divider"></div>

    <mat-card-content>
      <form [formGroup]="certificadoForm" novalidate (ngSubmit)="onSubmit()">

        <!-- VRI -->
        <div *ngIf="codigoHash; else vrfForm" class="form-grid">
          <mat-form-field appearance="outline" class="full">
            <mat-label>Código de seguridad</mat-label>
            <input matInput type="text" formControlName="CODIGO_SEGURIDAD" autocomplete="one-time-code">
            <mat-hint>Ingresa el código que figura en el certificado</mat-hint>
            <mat-error *ngIf="certificadoForm.get('CODIGO_SEGURIDAD')?.hasError('required')">
              El código de seguridad es obligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <!-- VRF -->
        <ng-template #vrfForm>
          <div class="form-grid">
            <mat-form-field appearance="outline" class="full">
              <mat-label>Proyecto</mat-label>
              <mat-select formControlName="PROYECTO" placeholder="Seleccione proyecto">
                <mat-option *ngFor="let proyecto of proyectosConfig" [value]="proyecto.proyecto">
                  {{ proyecto.proyecto }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="certificadoForm.get('PROYECTO')?.hasError('required')">
                Debe seleccionar un proyecto
              </mat-error>
            </mat-form-field>

            <!--mat-form-field appearance="outline" class="full">
              <mat-label>Fecha</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="FECHA" placeholder="Seleccione fecha">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="certificadoForm.get('FECHA')?.hasError('required')">
                Debe seleccionar una fecha
              </mat-error>
            </mat-form-field-->

            <mat-form-field appearance="outline" class="full">
              <mat-label>Fecha <span class="span-required">*</span></mat-label>
            
              <input matInput
                     [matDatepicker]="picker"
                     formControlName="FECHA"
                     placeholder="Seleccione fecha"
                     (click)="picker.open()"
                     readonly>
            
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            

            <div class="notice" *ngIf="showProjectFields">
              Complete los datos para consultar el certificado.
            </div>

            <mat-form-field appearance="outline" class="half" *ngIf="showProjectFields">
              <mat-label>Número de certificado</mat-label>
              <input matInput type="text" formControlName="NRO_CERTIFICADO" inputmode="numeric">
              <mat-error *ngIf="certificadoForm.get('NRO_CERTIFICADO')?.hasError('required')">
                Debe ingresar el número del certificado
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="half" *ngIf="showProjectFields">
              <mat-label>Número de suministro</mat-label>
              <input matInput type="text" formControlName="NRO_SUMINSTRO" inputmode="numeric">
              <mat-error *ngIf="certificadoForm.get('NRO_SUMINSTRO')?.hasError('required')">
                Debe ingresar el número del suministro
              </mat-error>
            </mat-form-field>
          </div>
        </ng-template>

        <!-- Loading -->
        <div class="loading" *ngIf="isLoading">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <div class="loading__text">{{ loadingText }}</div>
        </div>

        <!-- CTA -->
        <button mat-raised-button type="submit" class="cta"
          [disabled]="isLoading || (codigoHash ? certificadoForm.invalid : (!showProjectFields || certificadoForm.invalid))">
          <mat-icon class="cta__icon">search</mat-icon>
          {{ isLoading ? 'Procesando...' : 'Consultar' }}
        </button>

      </form>
    </mat-card-content>
  </mat-card>
</div>

<!-- visor -->
<div class="viewer" *ngIf="!view">
  <mat-toolbar class="toolbar">
    <img class="toolbar__logo"
         src="https://tdemperu.com/tdem/wp-content/uploads/2025/01/LOGO-TDEM-original.jpg"
         alt="TDEM SRL">
    <span class="toolbar__title">Consulta de Certificado</span>
    <span class="spacer"></span>
    <button mat-stroked-button color="white" (click)="exit()">
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>
  </mat-toolbar>

  <div class="iframe-wrap">
    <iframe [src]="urlPDF"></iframe>
  </div>
</div>
